export const cities = [
  { name: '台南市', countyNumber: '67000' },
  { name: '高雄市', countyNumber: '64000' },
]

export const tainan = [
  { num: 1, name: '新營區' },
  { num: 2, name: '鹽水區' },
  { num: 3, name: '白河區' },
  { num: 4, name: '柳營區' },
  { num: 5, name: '後壁區' },
  { num: 6, name: '東山區' },
  { num: 7, name: '麻豆區' },
  { num: 8, name: '下營區' },
  { num: 9, name: '六甲區' },
  { num: 10, name: '官田區' },
  { num: 11, name: '大內區' },
  { num: 12, name: '佳里區' },
  { num: 13, name: '學甲區' },
  { num: 14, name: '西港區' },
  { num: 15, name: '七股區' },
  { num: 16, name: '將軍區' },
  { num: 17, name: '北門區' },
  { num: 18, name: '新化區' },
  { num: 19, name: '善化區' },
  { num: 20, name: '新市區' },
  { num: 21, name: '安定區' },
  { num: 22, name: '山上區' },
  { num: 23, name: '玉井區' },
  { num: 24, name: '楠西區' },
  { num: 25, name: '南化區' },
  { num: 26, name: '左鎮區' },
  { num: 27, name: '仁德區' },
  { num: 28, name: '歸仁區' },
  { num: 29, name: '關廟區' },
  { num: 30, name: '龍崎區' },
  { num: 31, name: '永康區' },
  { num: 32, name: '東區' },
  { num: 33, name: '南區' },
  { num: 34, name: '北區' },
  { num: 35, name: '安南區' },
  { num: 36, name: '安平區' },
  { num: 37, name: '中西區' },
]

export const kaohsiung = [
  { name: '鹽埕區', num: 1 },
  { name: '鼓山區', num: 2 },
  { name: '左營區', num: 3 },
  { name: '楠梓區', num: 4 },
  { name: '三民區', num: 5 },
  { name: '新興區', num: 6 },
  { name: '前金區', num: 7 },
  { name: '苓雅區', num: 8 },
  { name: '前鎮區', num: 9 },
  { name: '旗津區', num: 10 },
  { name: '小港區', num: 11 },
  { name: '鳳山區', num: 12 },
  { name: '林園區', num: 13 },
  { name: '大寮區', num: 14 },
  { name: '大樹區', num: 15 },
  { name: '大社區', num: 16 },
  { name: '仁武區', num: 17 },
  { name: '鳥松區', num: 18 },
  { name: '岡山區', num: 19 },
  { name: '橋頭區', num: 20 },
  { name: '燕巢區', num: 21 },
  { name: '田寮區', num: 22 },
  { name: '阿蓮區', num: 23 },
  { name: '路竹區', num: 24 },
  { name: '湖內區', num: 25 },
  { name: '茄萣區', num: 26 },
  { name: '永安區', num: 27 },
  { name: '彌陀區', num: 28 },
  { name: '梓官區', num: 29 },
  { name: '旗山區', num: 30 },
  { name: '美濃區', num: 31 },
  { name: '六龜區', num: 32 },
  { name: '甲仙區', num: 33 },
  { name: '杉林區', num: 34 },
  { name: '內門區', num: 35 },
  { name: '桃源區', num: 37 },
]



// WEBPACK FOOTER //
// ./src/constants/teamBuildLocation.js